import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams, useLocation } from "react-router-dom";
import { getDdOptionForUI } from "../../store/reducer/ddOption/ddOptionSlice";
import {
  getSingleSnags,
  editExpenseSnags,
  delExpensePhoto,
} from "../../store/reducer/drawing/drawingSlice";
import Notes from "../Notes/Notes";
import { toast } from "react-toastify";
import DrawingTabs from "./DrawingTabs";

function EditExpenseSnags() {
  const { id, drawing_id, snag_id } = useParams();

  const dispatch = useDispatch();
  const location = useLocation();
  const [opportunityData, setOpportunityData] = useState([]);
  const [customerEditData, setEditCustomerData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(getDdOptionForUI());
    if (snag_id) {
      dispatch(getSingleSnags(snag_id)).then((result) => {
        if (result.payload) {
          setEditCustomerData(result.payload.data);
          setLoading(false);
        }
      });
    }
  }, []);

  const initialValues = {
    snag_id: snag_id,
    title: customerEditData?.title || "",
    location: customerEditData?.location || "",
    comments: customerEditData?.comments || "",
    date_reported: customerEditData?.date_reported || "",
    date_completed: customerEditData?.date_completed || "",
    before_photo: customerEditData?.before_photo || [],
    after_photo: customerEditData?.after_photo || [],
    before_video: customerEditData?.before_video || [],
    after_video: customerEditData?.after_video || [],
    status: 660,
  };

  const handleSubmit = (values) => {
    setLoading(true);
    const formData = new FormData();

    Object.keys(values).forEach((fieldName) => {
      formData.append(fieldName, values[fieldName]);
    });

    if (snag_id) {
      formData.append("snag_id", snag_id);
    }

    if (values.before_photo) {
      values.before_photo.forEach((file) => {
        formData.append("before_photo", file);
      });
    }

    if (values.after_photo) {
      values.after_photo.forEach((file) => {
        formData.append("after_photo", file);
      });
    }

    if (values.before_video) {
      values.before_video.forEach((file) => {
        formData.append("before_video", file);
      });
    }

     if (values.after_video) {
      values.after_video.forEach((file) => {
        formData.append("after_video", file);
      });
    }

    dispatch(editExpenseSnags(formData)).then((result) => {
      if (result.payload != undefined) {
        toast.success(result.payload.message);
      } else {
        toast.error("Server error...");
      }
      setLoading(false);
    });
  };

  const handleRemove = (id) => {
    setLoading(true);
    dispatch(delExpensePhoto(id)).then((result) => {
      if (result.payload != undefined) {
        toast.success(result.payload.message);
        if (snag_id) {
          dispatch(getSingleSnags(snag_id)).then((result) => {
            if (result.payload) {
              setEditCustomerData(result.payload.data);
              setLoading(false);
            }
          });
        }
      } else {
        toast.error("Server error...");
      }
      setLoading(false);
    });
  };

  return (
    <>
      <div className="grid grid-cols-3 items-center mb-[30px]">
        <div className="flex gap-[16px] items-center">
          <Link to={`/opportunity/${id}`}>
            <div className="bg-[#F8F8F8] rounded-[10px] p-[8px]">
              <img
                className="w-[24px]"
                src={process.env.PUBLIC_URL + "/icons/back.png"}
                alt="back icon"
              />
            </div>
          </Link>
          <div className="flex flex-col">
            <span className="font-Inter font-[400] leading-[16px] text-[#9E9E9E] text-[14px]">
              Snags
            </span>
            <span className="font-Inter font-[700] leading-[30px] text-[24px]">
              Snags
            </span>
          </div>
        </div>
        <div className="font-Inter font-[500] leading-[30px] text-[18px] text-center">
          {opportunityData.id}-{drawing_id}-{opportunityData.opportunity_name}
        </div>
        <Notes
          type="drawing-commercialinvoice-history"
          drawing_id={drawing_id}
        />
      </div>

      <DrawingTabs />

      {loading ? (
        <div className="text-center">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2xl"
            style={{ color: "#55A14A" }}
            spin
          />
        </div>
      ) : (
        <div className="flex flex-col mt-[20px] gap-[40px]">
          <div className="w-full mt-6">
            <div className="bg-[#F8F8F8] rounded-[12px] p-6">
              <div className="md:flex justify-between items-center p-[12px]">
                <div className="leading-[30px] font-Mulish font-[700] text-[20px] mb-[8px] md:mb-0">
                  <span>Add Snags</span>
                </div>
                {/* <div className="flex justify-end">
                  <a
                    href={`/opportunity/${id}/drawing/${drawing_id}/expense-snags-list`}
                    className="bg-[#55A14A] text-white px-5 py-2 rounded-lg hover:bg-[#3A8A3A]"
                  >
                    Snag List
                  </a>
                </div> */}
              </div>

              <div className="mt-4">
                <Formik
                  initialValues={initialValues}
                  enableReinitialize
                  onSubmit={handleSubmit}
                >
                  {({
                    isSubmitting,
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleSubmit,
                  }) => (
                    <Form>
                      <div className="md:flex justify-between  p-[12px]">
                        <div className="w-[45%]">
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="title"
                            >
                              Title of Snag
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="title"
                              type="text"
                              name="title"
                              placeholder="Enter title of snag"
                              required
                              value={values.title}
                              onChange={(e) => {
                                setFieldValue("title", e.target.value);
                              }}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="beforephoto"
                            >
                              Before Photo
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="before_photo"
                              type="file"
                              name="before_photo"
                              accept="image/*"
                              placeholder="Upload before photo"
                              multiple
                              onChange={(e) => {
                                setFieldValue("before_photo", [
                                  ...e.target.files,
                                ]);
                              }}
                            />
              
                            <div className="grid grid-cols-8 gap-2">
                              {values.before_photo.map((f, i) => (
                                <div key={i}>
                                  {f.url && (
                                    <>
                                    <button
                                        className="bg-[#af3931b0]  text-white font-bold py-1 px-2 rounded"
                                        style={{
                                          position: "relative",
                                          top: "32px",
                                        }}
                                        onClick={() => handleRemove(f.id)}
                                      >
                                        X
                                      </button>
                                      <a href={f.url}>
                                      <img
                                        src={f.url}
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          objectFit: "cover",
                                        }}
                                      /></a>
                                  
                                    </>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                             <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="beforephoto"
                          >
                            Before Video
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="before_video"
                            type="file"
                            name="before_video"
                            accept="video/*"
                            placeholder="Upload before video"
                            onChange={(e) => {
                              setFieldValue("before_video", [
                                ...e.target.files,
                              ]);
                            }}
                          />
                          {values.before_video && values.before_video.length > 0 ? (
                            <div className="mb-4">
                              {values.before_video.map((f, i) => (
                                <button className="bg-[#55A14A] hover:bg-[#4CAF50] text-white font-bold py-1 px-2 rounded" onClick={() => window.open(f.url)}>
                                  Play Video 
                                </button>
                              ))}
                            </div>
                          ) : null}
                        </div>
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="date_completed"
                            >
                              Date Completed
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="date_completed"
                              type="date"
                              name="date_completed"
                              placeholder="Enter date completed"
                              required
                              value={values.date_completed}
                              onChange={(e) => {
                                setFieldValue("date_completed", e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="w-[45%]">
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="location"
                            >
                              Location
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="location"
                              name="location"
                              placeholder="Enter location"
                              required
                              value={values.location}
                              onChange={(e) => {
                                setFieldValue("location", e.target.value);
                              }}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="comments"
                            >
                              Comments
                            </label>
                            <textarea
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="comments"
                              name="comments"
                              placeholder="Enter comments"
                              required
                              value={values.comments}
                              onChange={(e) => {
                                setFieldValue("comments", e.target.value);
                              }}
                            />
                          </div>
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="afterphoto"
                            >
                              After Photo
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id="after_photo"
                              type="file"
                              name="after_photo"
                              accept="image/*"
                              placeholder="Enter after photo"
                              multiple
                              onChange={(e) => {
                                setFieldValue("after_photo", [
                                  ...e.target.files,
                                ]);
                              }}
                            />
            
                             <div className="grid grid-cols-8 gap-2">
                              {values.after_photo.map((f, i) => (
                                <div key={i}>
  
                                  {f.url && (
                                    <>
                                      <button
                                        className="bg-[#af3931b0]  text-white font-bold py-1 px-2 rounded"
                                        style={{
                                          position: "relative",
                                          top: "32px",
                                        }}
                                        onClick={() => handleRemove(f.id)}
                                      >
                                        X
                                      </button>
                                      <a href={f.url}>
                                      <img
                                        src={f.url}
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          objectFit: "cover",
                                        }}
                                      /></a>
                                    
                                    </>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="afterphoto"
                          >
                            After Video
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="after_video"
                            type="file"
                            name="after_video"
                            accept="video/*"
                            placeholder="Enter after video"
                            onChange={(e) => {
                              setFieldValue("after_video", [...e.target.files]);
                            }}
                          />
                            {values.after_video && values.after_video.length > 0 ? (
                            <div className="mb-4">
                              {values.after_video.map((f, i) => (
                                <button className="bg-[#55A14A] hover:bg-[#4CAF50] text-white font-bold py-1 px-2 rounded" onClick={() => window.open(f.url)}>
                                  Play Video 
                                </button>
                              ))}
                            </div>
                          ) : null}
                        </div>
                          <div className="mb-4">
                            <label
                              className="block text-gray-700 text-sm font-bold mb-2"
                              htmlFor="datereport"
                            >
                              Date Reported
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                              id=" date_reported"
                              type="date"
                              name=" date_reported"
                              placeholder="Enter date reported"
                              required
                              value={values.date_reported}
                              onChange={(e) => {
                                setFieldValue("date_reported", e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center mt-6">
                        <button className="bg-[#55A14A] hover:bg-[#4CAF50] text-white font-bold py-2 px-4 rounded">
                          Update
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EditExpenseSnags;
